<ng-container>
  @if (data) {
    <div class="block bold">
      <span id="securityRowCount">{{securityRowCount}}</span> security restrictions; <span id="categoryRowCount">{{categoryRowCount}}</span> category restrictions
    </div>
  }
  <div class="block" style="display:flex; flex-direction: row; gap: 10px;">
    <div style="display:flex; flex-direction: row; gap: 5px;">
      <span>Security Restriction</span><span class="infoIcon" calltoaction [calltoactionTemplate]="securityRestrictionToolTipIcon"></span>
      <irb-dropdown-search #securityRestrictionsDropdown (search)="populateSecurityRestrictions($event)"
        (openNewItemFlow)="openNewItemSecurityFlow($event, false)"
        [addNewItem]="addNewSecurityItem"
        (selection)="selectSecurityRestriction($event)"
        (clearSelection)="clearSecurityRestriction()"
      ></irb-dropdown-search>

      <div style="position:relative;margin-right: 10px;">
        <button class="btn-medium-secondary btn-spacer" label="Add" (click)="addSecurityRestriction()" [disabled]="!checkSecurityRestriction">Add</button>
        @if (!checkSecurityRestriction) {
          <div
            style="position:absolute;left:0;top:0;z-index: 9999; width: 65px; height: 25px" #securityRestrictionTooltip
            tooltip tooltipPosition="right" [tooltipTitle]="valSecDupMessage" tooltipClass="error">
          </div>
        }
      </div>
    </div>
    <div style="display:flex; flex-direction: row; gap: 5px;" >
      <span>Category Restriction</span><span class="infoIcon" calltoaction [calltoactionTemplate]="categoryRestrictionToolTipIcon"></span>
      <irb-dropdown-search-multiple style="margin-left: 5px" #categoryRestrictionsDropdown (search)="populateCategoryRestrictionsMultiple($event)" size="30"
        [addNewItem]="addNewCategoryItem"
        (openNewItemFlow)="openNewItemCategoryFlow($event)"
        [enableHiddenSearchResults]="false"
        [enableEmptySearchTerm]="true" showApplyButton="true"
      (applySelection)="onAddMultipleCategoryRestrictions($event)"></irb-dropdown-search-multiple>
    </div>
  </div>
  @if (!isUiTest) {
    <irb-inventory-grid
      class="restrictionGrid"
      [style.width]="'100%'"
      [gridHeight]="'200px'"
      [showSideBar]="false"
      [gridOptions]="gridOptions"
      [frameworkComponents]='frameworkComponents'
    (gridReady)="onGridReady($event)"></irb-inventory-grid>
  }
</ng-container>

<ng-template #comRestrictionsDeleteOverlay>
  <div class="block">Remove this portfolio-specific restriction?</div>
  <div class="buttonSet" style="margin-right: 35px;">
    <button (click)="cancelDelete()" class="btn-medium-secondary">Cancel</button>
    <button (click)="delete(deleteTarget)" class="btn-medium-primary">Remove</button>
  </div>
</ng-template>
<ng-template #securityRestrictionToolTipIcon>
  <div>You can set security restrictions that will apply to this portfolio only (overriding any restriction set in the security master or in the model assigned above and overriding any asset category restriction set in the portfolio).
  </div>
</ng-template>
<ng-template #categoryRestrictionToolTipIcon>
  <div>You can also set restrictions on groups of securities by using your custom asset categories. Asset category restrictions will complement any restrictions set for individual securities in the security master or in the model.
  </div>
</ng-template>
